import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ProfileContent } from '../../../components/Layout/InternalLayout/ProfileContent';
import { StackContainer } from '../../../components/Layout/InternalLayout/StyledComponentsProfile';
import Spinner from '../../../components/Spinner';
import DialogBox from '../../../components/UI/modal';
import { NotificationsXcala } from '../../../components/XcalaComponents/Notifications/NotificationsXcala';
import useModal from '../../../hooks/custom/useModal';
import { resetUpdateUserAttributesSubmit, updateUserAttributesSubmit } from '../../../redux/auth';
import capitalize from '../../../utils/capitalize';
import { contentAgresivo, contentConservador, contentModerado } from '../../../utils/constants';
import { onRefresh } from '../../../utils/refreshPage';

const ProfileSelect = () => {
  const {
    loadingUpdateUserAttributes,
    successUpdateUserAttributes,
    errorUpdateUserAttributes,
    user,
  } = useSelector(state => state.auth);

  const [selectedTitle, setSelectedTitle] = useState(
    user['custom:profile'] ? capitalize(user['custom:profile']) : null,
  );
  const [selectedContent, setSelectedContent] = useState(null);
  const [profile, setProfile] = useState('');
  const { isShowing, toggle } = useModal();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSelect = (title, content) => {
    setSelectedTitle(title);
    setSelectedContent(content);
  };

  const handleRiskProfile = riskProfile => {
    if (riskProfile === 'conservador') return '/assets/images/dashboard/perfiles/conservador.svg';
    if (riskProfile === 'moderado') return '/assets/images/dashboard/perfiles/moderado.svg';
    if (riskProfile === 'agresivo') return '/assets/images/dashboard/perfiles/agresivo.svg';
  };

  const pepModal = {
    className: 'profile-tab-popup',
    title: 'Antes de continuar...',
    content: 'Declaro entender y aceptar lo que implica identificarse con ese perfil de riesgo',
    btnContent: 'Entendido',
    btnContent2: 'Cancelar',
  };

  const profileContentMap = {
    conservador: contentConservador,
    moderado: contentModerado,
    agresivo: contentAgresivo,
  };

  const userCustomProfile = user['custom:profile'] ? user['custom:profile'].toLowerCase() : null;

  const userProfileContent = profileContentMap[userCustomProfile];

  const handleGoToQuestions = () => {
    navigate('/questions');
  };

  const handleClickOpen = value => {
    setProfile(value);
    setOpen(true);
  };

  const handleBtn = () => {
    setOpen(false);
    dispatch(updateUserAttributesSubmit({ name: 'custom:profile', value: profile }));
  };

  useEffect(() => {
    if (successUpdateUserAttributes && !loadingUpdateUserAttributes) {
      dispatch(resetUpdateUserAttributesSubmit());
      navigate('/myprofilerisk');
    }
  }, [loadingUpdateUserAttributes, successUpdateUserAttributes]);

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'onboarding profile',
        path: '/profile',
        link: {
          url: '/profile',
          title: 'onboarding',
        },
      },
    });
  }, []);

  if (loadingUpdateUserAttributes) {
    return <Spinner />;
  }
  if (errorUpdateUserAttributes) {
    return (
      <NotificationsXcala
        activation={!isShowing}
        message='Lo sentimos, ha ocurrido un error inesperado....'
        nameBtnTwo='Enviar error'
        toggle={toggle}
        refresh={onRefresh}
        error={errorUpdateUserAttributes}
      />
    );
  }

  return (
    <>
      <DialogBox
        setOpen={setOpen}
        open={open}
        className={pepModal.className}
        modal_title={pepModal.title}
        modal_content={pepModal.content}
        action_btn2={pepModal.btnContent2}
        action_btn={pepModal.btnContent}
        handleBtn={handleBtn}
      />
      <StackContainer>
        {user['custom:profile'] ? (
          <ProfileContent
            user={user}
            selectedContent={selectedContent || userProfileContent}
            selectedTitle={selectedTitle}
            handleSelect={handleSelect}
            handleGoToQuestions={handleGoToQuestions}
            handleClickOpen={handleClickOpen}
            handleRiskProfile={handleRiskProfile}
            navigate={navigate}
          />
        ) : (
          <ProfileContent
            user={user}
            selectedContent={selectedContent}
            selectedTitle={selectedTitle}
            handleSelect={handleSelect}
            handleGoToQuestions={handleGoToQuestions}
            handleClickOpen={handleClickOpen}
            handleRiskProfile={handleRiskProfile}
            navigate={navigate}
          />
        )}
      </StackContainer>
    </>
  );
};

export default ProfileSelect;
